export { default } from "./CookieConsentWidget.jsx"
